import React, { useState } from "react";
import "./Slider.css";
import BuyNowButton from "../assets/BuyNowButton.gif";

const Slider = ({
  filters,
  lensIndex,
  setLensIndex,
  buyNowUrl,
  handleShare,
  playCameraSound,
  customBuyNowImage,
}) => {
  const [transition, setTransition] = useState(false);
  const handleNext = () => {
    setTransition(true);
    setLensIndex((prevIndex) => (prevIndex + 1) % filters.length);
    setTimeout(() => setTransition(false), 300);
  };

  const handlePrev = () => {
    setTransition(true);
    setLensIndex((prevIndex) =>
      prevIndex === 0 ? filters.length - 1 : prevIndex - 1
    );
    setTimeout(() => setTransition(false), 300);
  };

  const handleBuyNow = () => {
    if (buyNowUrl) {
      window.open(buyNowUrl, "_blank");
    }
  };

  return (
    <div className="filter-slider">
      {lensIndex !== 0 ? (
        <div onClick={handlePrev} className="filter">
          <img src={filters[lensIndex - 1]} alt={`filter-${lensIndex}`} />
        </div>
      ) : (
        <div></div>
      )}

      <div
        onClick={() => {
          playCameraSound();
          handleShare();
        }}
        className="main-filter"
      >
        <img src={filters[lensIndex]} alt={`filter-${lensIndex}`} />
      </div>
      {lensIndex !== filters.length - 1 ? (
        <div onClick={handleNext} className="filter">
          <img src={filters[lensIndex + 1]} alt={`filter-${lensIndex}`} />
        </div>
      ) : (
        buyNowUrl && (
          <div onClick={handleBuyNow} className="filter">
            <img
              src={customBuyNowImage ? customBuyNowImage : BuyNowButton}
              alt={"Buy Now Button"}
            />
          </div>
        )
      )}
    </div>
  );
};

export default Slider;
